/**
 * @flow
 * @relayHash 6c83c6bc0df0ad879e08ddd4f939079e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteMachineTypeInput = {|
  id: string
|};
export type DeleteMachineTypeMutationVariables = {|
  input: DeleteMachineTypeInput
|};
export type DeleteMachineTypeMutationResponse = {|
  +deleteMachineType: {|
    +deletedId: string
  |}
|};
export type DeleteMachineTypeMutation = {|
  variables: DeleteMachineTypeMutationVariables,
  response: DeleteMachineTypeMutationResponse,
|};
*/


/*
mutation DeleteMachineTypeMutation(
  $input: DeleteMachineTypeInput!
) {
  deleteMachineType(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteMachineTypeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteMachineType",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteMachineTypePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteMachineTypeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteMachineTypeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteMachineTypeMutation",
    "id": null,
    "text": "mutation DeleteMachineTypeMutation(\n  $input: DeleteMachineTypeInput!\n) {\n  deleteMachineType(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7389920ce4ac36a86138701050ce7e3c';
module.exports = node;
